import vueSeamlessScroll from 'vue-seamless-scroll';
export default {
  name: 'shopRank',
  props: {
    rankData: Array
  },
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      classOption: {
        step: 0.3,
        waitTime: 500,
        autoPlay: true,
        switchDelay: 1000,
        singleHeight: 46,
        hoverStop: true,
        limitMoveNum: 6,
        singleHeight: 0,
        // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0,
        openWatch: true,
        direction: 1
      },
      rankIndex: {
        1: 'diyi',
        2: 'dierming',
        3: 'disanming'
      },
      timer: null,
      //这里加个key值来刷新 滚动 从第一个开始
      num: Math.random(0, 1000)
    };
  },
  computed: {
    max() {
      if (this.rankData.length === 0) return 0;
      return this.rankData[0].value;
    }
  },
  methods: {
    filterValue(val) {
      if (!val || this.max === 0) {
        return 0;
      }
      return parseInt(val / this.max * 100);
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  watch: {
    rankData: {
      handler(nl, ol) {
        this.classOption.autoPlay = false;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.num = Math.random() * 100;
        this.timer = setTimeout(() => {
          this.classOption.autoPlay = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, 2000);
      },
      deep: true
    }
  }
};